import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { Socket, io } from 'socket.io-client';
import { AuthService } from '../auth/auth.service';
import { WebSocketEvent, WebsocketEventType } from './events.type';

@Injectable({ providedIn: 'root' })
export class WebsocketService<T> {
    private socket!: Socket | null;
    private update = new BehaviorSubject<WebSocketEvent<T> | null>(null);
    private _isConnected = new BehaviorSubject<boolean>(false);

    /**
     * Constructor
     */
    constructor(private _authService: AuthService) {
        this._authService.check().subscribe((status) => {
            if (status) {
                this.connectSocket();
            } else {
                this.disconnectSocket();
            }
        });
    }

    set isConnected(status: boolean) {
        this._isConnected.next(status);
    }

    get isConnected$(): Observable<boolean> {
        return this._isConnected.asObservable();
    }

    on(
        eventType: WebsocketEventType,
        collection: string
    ): Observable<WebSocketEvent<T> | null> {
        return this.update.pipe(
            filter(
                (data) =>
                    !!data &&
                    data.type === eventType &&
                    data.collection === collection
            )
        );
    }

    private setupSocket() {
        this.socket = io(`${environment.apiUrl}/ws`, {
            auth: { token: 'Bearer ' + this._authService.accessToken },
        });

        this.socket.on('connect', () => {
            this.isConnected = true;
        });

        this.socket.on('disconnect', () => {
            this.isConnected = false;
        });

        this.socket.on('events', (data) => {
            this.update.next(data);
        });
    }

    private connectSocket() {
        if (!this.socket || !this.socket.connected) {
            this.setupSocket();
        }
    }

    private disconnectSocket() {
        if (this.socket && this.socket.connected) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}
